import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdvAdvertisementModel } from '../model/AdvAdvertisementModel';
import { AdvBoardModel } from '../model/AdvBoardModel';
import { AdvertisementLotteryListWrapperResponse } from '../model/AdvertisementLotteryListWrapperResponse';

@Injectable({
  providedIn: 'root'
})
export class AdvAdvertisementService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }
  
  getAdvertisements() {
    return this.httpClient.get<AdvAdvertisementModel>(
      ApiUrls.getAdvAdvertisementsUrl);
  }
  
  deleteAdvertisement(id: number) {
    return this.httpClient.delete(ApiUrls.deleteAdvAdvertisementsUrl.replace('{id}', id.toString()));
  }
  
  findBoardsForAdvertisement() {
    return this.httpClient.get<AdvBoardModel>(
      ApiUrls.getAdvAdvertisementBoardsUrl);
  }  

  fetchPreparationStageLotteriesForBoard(boardId: string) {
    return this.httpClient.get<AdvertisementLotteryListWrapperResponse>(
      ApiUrls.getAdvLotteriesByBoardUrl.replace('{boardId}', boardId));
  }

  fetchLotteryDetail(id: number) {
    return this.httpClient.get<AdvertisementLotteryListWrapperResponse>(
      ApiUrls.getAdvLotteryDetailUrl.replace('{id}', id.toString()));
  }

  saveAdvertisement(res: any) {
    return this.httpClient.post<AdvAdvertisementModel>(
      ApiUrls.saveAdvAdvertisementsUrl, res);
  }

  getAdvertisementDetail(id: number) {
    return this.httpClient.get(ApiUrls.getAdvAdvertisementDetailUrl.replace('{id}', id.toString()));
  }

  updateAdvertisement(advertisementData: any) {
    return this.httpClient.put(ApiUrls.updateAdvAdvertisementUrl, advertisementData);
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
